// 用户 付费 保留期 提示
import paddle from '../../lib/paddle'
import { Button, message } from 'antd'
import oGet from 'lodash/get'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import React, { useCallback, useState } from 'react'
import productApi from '../../api/product'
import { Config } from '../../utils/config'
import './SubScriptionExpired.less'

function SubScriptionExpired(props) {
  const userStore = props.userStore
  const {
    userMemberStatusIsHolding,
    userMemberStatusIsExpired,
    userInfo,
    isUserFreeType,
    subscriptionCanResume, //暂停
    subIsPastDue, //扣款失败
    isDeletedSubscriptionCanResume, //用户已经在paddle删除订阅, 可以重新调用paddle绑卡恢复
  } = userStore
  const subscriptionData = userStore.currentSubscription

  const [resumeLoading, setResumeLoading] = useState(false)

  const memberHoldingTime = oGet(userInfo, 'memberHoldingTime', 0)

  const endTime = moment().add(memberHoldingTime, 'seconds')

  const days = endTime.diff(moment(), 'days')
  const hours = endTime.diff(moment(), 'hours') % 24

  const timeText = days === 0 ? `${hours} hours` : `${days} days`

  // resume plan
  const onResumeClick = useCallback(() => {
    setResumeLoading(true)
    const subscriptionId = userStore.currentSubscription.subscriptionId
    productApi
      .restartPlan({ subscriptionId })
      .then((_) => {
        message.success('Resume successfully!')
        // 更新用户相关信息
        userStore.requestUserInfo()
        userStore.requestUserPhones()
        userStore.requestSubscriptionDetail()
      })
      .finally((_) => {
        setResumeLoading(false)
      })
  }, [])

  // 扣款失败, 更新 payment method
  const updateSubPaymentMethod = useCallback(() => {
    paddle
      .init()
      .then((_) => {
        return paddle.updatePayment(subscriptionData.updateUrl)
      })
      .then((_) => {
        // Checkout.PaymentMethodSelected
      })
  }, [subscriptionData])

  const HoldText = (
    <div className="t1">
      Your plan has been cancelled and has expired. Your fax number will be revoked in <b>{timeText}</b>. Please renew
      your plan.
    </div>
  )

  const PayFailText = (
    <div className="t1">
      Payment for subscription was unsuccessful. Your plan has expired. Your fax number will be revoked in{' '}
      <b>{timeText}</b>. Please update your payment information if necessary.
    </div>
  )

  const FreeText = <div className="t1">Upgrade to get a PERMANENT fax number and be able to receive faxes.</div>
  const FreeExpiredText = (
    <div className="t1">
      Your plan has expired. To continue receiving faxes，please upgrade to obtain a PERMANENT fax number.
    </div>
  )
  const UpdateButton = (
    <Button size="small" type="danger" onClick={() => (window.location.href = Config.PRICING_URL)}>
      Update Now
    </Button>
  )

  let btn = UpdateButton
  let text = FreeText

  if (isUserFreeType) {
    // 免费用户
    btn = UpdateButton
    text = FreeText
    if (userMemberStatusIsExpired) {
      // 过期导致的免费用户
      btn = UpdateButton
      text = FreeExpiredText
    }
  } else if (userMemberStatusIsHolding && memberHoldingTime > 0) {
    // holding
    btn = subIsPastDue ? (
      <Button size="small" type="primary" onClick={updateSubPaymentMethod}>
        Update Now
      </Button>
    ) : subscriptionCanResume ? (
      <Button size="small" type="primary" loading={resumeLoading} onClick={onResumeClick}>
        Resume Plan
      </Button>
    ) : isDeletedSubscriptionCanResume ? (
      <Button
        size="small"
        type="danger"
        loading={resumeLoading}
        onClick={() => (window.location.href = '/page/profile/billing')}
      >
        Resume Plan
      </Button>
    ) : (
      <Button size="small" type="danger" onClick={() => (window.location.href = Config.PRICING_URL)}>
        Renew Plan
      </Button>
    )
    text = subIsPastDue ? PayFailText : HoldText
  } else {
    return null
  }

  return (
    <div className="SubScriptionExpired">
      <div className="safe-wrapper">
        {text}
        {btn}
      </div>
    </div>
  )
}

export default inject('userStore')(observer(SubScriptionExpired))
